<template>
  <div class="content-manageCod">
    <base-header type="gradient-blue" class="base-content pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-6 col-md-6 col-lg-6">
                <h1 class="text-white pt-3">จัดการรายการ COD</h1>
                <p class="text-white pb-0">ตารางสรุปข้อมูลจำนวนยอดส่ง COD และจัดการรายการโอนเงิน COD</p>
            </div>
            <div class="d-flex justify-content-end col-6 col-md-6 col-lg-6 py-5">
            </div>
      </div>
    </base-header>
    <BlockUI class="text-center" v-if="busy">
        <div class="loader"></div>
    </BlockUI>
    <div class="main-content px-5">
        <div class="nav-content d-flex justify-content-start">
            <div class="btn-left" :class="menu === 'listCod' ? 'btn-active' : 'btn-non-active'" @click="menuAction('listCod')"><strong>รายการลูกค้า COD</strong></div>
            <div class="btn-right" :class="menu === 'sumTotalCod' ? 'btn-active' : 'btn-non-active'" @click="menuAction('sumTotalCod')"><strong>สรุปยอดรวม COD</strong></div>
        </div>
        <div v-if="menu === 'listCod'" class="" style="background-color: white;">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-12">
                                    <div class="col-lg-12">
                                        <b-form-group class="mb-0" >
                                            <div class="row">
                                                <div class="col-lg-9 col-sm-12">
                                                    <div class="row">
                                                        <div class="col-lg d-flex flex-column justify-content-between">
                                                            <base-input
                                                                formClasses="mb-0"
                                                                alternative
                                                                label="วันที่เริ่มต้น"
                                                                typeInput="date"
                                                                placeholder="dd/mm/yyyy"
                                                                size="lg"
                                                                v-model="search.dateStart"  
                                                            />
                                                        </div>
                                                        <div class="col-lg d-flex flex-column justify-content-between">
                                                            <base-input
                                                                formClasses="mb-0"
                                                                alternative
                                                                label="วันที่สิ้นสุด"
                                                                typeInput="date"
                                                                placeholder="dd/mm/yyyy"
                                                                size="lg"
                                                                v-model="search.dateEnd"  
                                                            />
                                                        </div>  
                                                        <div class="col-lg d-flex flex-column justify-content-between">
                                                            <label for="">สถานะการโอน</label>
                                                            <select class="form-control" @change="statusChange" 
                                                                v-model="search.status">
                                                                <option :value="'allstatus'">ดูทั้งหมด</option>
                                                                <option :value="status.key" v-for="status in statusData" :key="status.key">{{status.title}}</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-lg d-flex flex-column justify-content-between">
                                                            <label for=""></label>
                                                            <base-input
                                                                formClasses="mb-0"
                                                                alternative
                                                                typeInput=" text"
                                                                placeholder="ค้นหาด้วยชื่อลูกค้า"
                                                                size="lg"
                                                                v-model="search.name"  
                                                            />
                                                        </div>
                                                        <div class="col-lg-2 mt-2 d-flex flex-column justify-content-end">
                                                            <button class="btn btn-info btn-sm-res" @click="getDataTransfer('listCod')">
                                                            <i class="fa fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 col-sm-12 mt-2 d-flex align-items-end justify-content-center">
                                                    <div class="w-100 container">
                                                        <button class="btn btn-info w-100" @click="getDataTransfer('is_excel_report')">
                                                            <span>
                                                                <img :src="icon.upload" alt="uploadicon">                    
                                                                Export
                                                            </span>                                                        
                                                        </button>  
                                                    </div>
                                                </div>
                                            </div>
                                        </b-form-group>
                                        <hr class="d-md-none d-lg-none" />
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                        <hr class="d-block d-md-none d-lg-none mb-0" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ReportCodTable :items="items" :fields="fields" :search="search" :dateStart="search.dateStart" :dateEnd="search.dateEnd" ref="reportShopCODCommission" :totalItems="totalItems"></ReportCodTable>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="menu === 'sumTotalCod'" class="" style="background-color: white;">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-12">
                                    <div class="col-lg-12">
                                        <b-form-group class="mb-0" >
                                            <div class="row">
                                                <div class="col-lg-6 col-sm-12">
                                                    <div class="row">
                                                        <div class="col-lg d-flex flex-column justify-content-between">
                                                            <base-input
                                                                formClasses="mb-0"
                                                                alternative
                                                                label="วันที่เริ่มต้น"
                                                                typeInput="date"
                                                                placeholder="dd/mm/yyyy"
                                                                size="lg"
                                                                v-model="search.dateStart"  
                                                            />
                                                        </div>
                                                        <div class="col-lg d-flex flex-column justify-content-between">
                                                            <base-input
                                                                formClasses="mb-0"
                                                                alternative
                                                                label="วันที่สิ้นสุด"
                                                                typeInput="date"
                                                                placeholder="dd/mm/yyyy"
                                                                size="lg"
                                                                v-model="search.dateEnd"  
                                                            />
                                                        </div>
                                                        <div class="col-lg-3 w-100 d-flex flex-column justify-content-end">
                                                            <button class="w-100 mt-3 btn btn-info btn-sm-res" @click="getSumTotalCOD()">
                                                                <i class="fa fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3 col-sm-12">

                                                </div>
                                                <div class="col-lg-3 mt-sm-3 col-sm-12 d-flex align-items-end justify-content-center">
                                                    <div class="w-100 container">                                                    
                                                        <button class="btn btn-info w-100" @click="ExportSumCOD()">
                                                            <span>
                                                                <img :src="icon.upload" alt="uploadicon">                    
                                                                Export
                                                            </span>                                                         
                                                        </button>  
                                                    </div>
                                                </div>
                                            </div>
                                        </b-form-group>
                                        <hr class="d-md-none d-lg-none" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SumCodTable :items="ItemSumCOD" :fields="fieldSumCOD" :KeyTables="allKeyTables" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modalSelect-Export">
        <ModalSelectCOD :load="loadExport" fileName="CODREPORT" :modalExport="modal.Export" :search="search" ref="modalExport" @close="close($event)"/>
    </div>
    <div class="modalSelect-Import">
        <ModalImportCod :modalExport="modal.Import" :search="search" ref="modalImport" @close="close($event)"/>
    </div>
    <div class="modalConfirm">
        <b-modal
              centered
              hide-footer
              hide-header-close
              hide-header
              v-model="modal.confirmStatus"
          >
              <template slot="default">
                  <div class="d-flex justify-content-center align-items-center">
                      <h3 class="mb-0">
                        <b>ปรับสถานะการโอน</b>
                      </h3>
                  </div>
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <p class="mb-0">ยืนยันการปรับสถานะเป็นโอนเงินแล้ว</p>
                    <p>ทั้งหมด {{ selected.length }} รายการ ใช่หรือไม่ ?</p>
                  </div>
                  <div class="d-flex align-items-start justify-content-center">
                    <b-button class="border" variant="outline-secondary" @click="close('confirmStatus')">ยกเลิก</b-button>
                    <b-button class="border" variant="success" @click="close('confirmStatus')" >ยืนยัน</b-button>
                  </div>
              </template>
          </b-modal>
    </div>
  </div>
</template>

<script>
import ReportCodTable from '@/components/custom/reports/cod/ReportCodTable'
import SumCodTable from '@/components/custom/reports/cod/SumCodTable'
import ReportCodField from '@/constants/ReportCodField'
import ModalSelectCOD from '@/components/Modals/ModalSelectCOD.vue'
import ModalImportCod from '@/components/Modals/ModalImportCod.vue'
import { courierName } from "@/plugins/courierName.js";
import moment from "moment";

export default {
    components: {
        SumCodTable,
        ReportCodTable,
        ModalSelectCOD,
        ModalImportCod
    },
    data () {
        return {
            icon: {
              upload: require('../../assets/icon/UploadSimple.svg')  
            },
            loadExport: false,
            selected: [],
            fields: ReportCodField,
            columnReportCod: [
                {
                    key: "selected",
                    label: "เลือกรายการ",
                },
                {
                    key: "index",
                    label: "ลำดับ",
                },
                {
                    key: "bank_account_name",
                    label: "ชื่อลูกค้า",
                },
                {
                    key: "bank_account_id",
                    label: "ข้อมูลธนาคาร",
                },
                {
                    key: "cod_amount",
                    label: "ยอดเก็บ COD (บาท)",
                },
                {
                    key: "cod_fee",
                    label: "ค่าบริการ (บาท)",
                },
                {
                    key: "cod_vat",
                    label: "VAT (บาท)",
                },
                {
                    key: "calulate_cod",
                    label: "ยอดคืน COD (บาท)",
                },
                {
                    key: "state",
                    label: "สถานะ",
                },
                {
                    key: "remark",
                    label: "หมายเหตุ",
                },
                {
                    key: "actions",
                    label: "การจัดการ",
                },
                {
                    label: "รหัสร้าน",
                    field: "shop_code"
                },
                {
                    label: "ชื่อร้าน",
                    field: "shop_name"
                },
                {
                    label: "ประเภทลูกค้า",
                    field: "customer_type"
                },
                {
                    label: "จำนวนพัสดุ",
                    field: "nums"
                },
                {
                    label: "ยอดรวม COD",
                    field: "cod_amount"
                },
                {
                    label: "ยอดรวม Commission",
                    field: "commission"
                },
                {
                    label: "หักภาษี ณ ที่จ่าย",
                    field: 'withholding_tax'
                },
                {
                    label: "ยอด Commission ก่อน VAT 7%",
                    field: 'exclude_vat'
                }

            ],
            fieldSumCOD: [],
            ItemSumCOD: [],
            allKeyTables: [],
            modal: {
                Export: false,
                Import: false,
                confirmStatus: false,
            },
            busy: false,
            menu: 'listCod',
            search: {
                date: moment(new Date(Date.now())).format("YYYY-MM-DD HH:mm:ss"),
                name: "",
                status: "allstatus",
                page: 1,
                perPage: 100,
                selectedBank: false,
                dateStart: "",
                dateEnd: "",
            },
            statusData: [
                {key: "transferred" , title: "โอนเงินแล้ว"},
                {key: "rejected" , title: "ยังไม่ได้โอนเงิน"}
            ],
            items: [],
        }
    },
    computed: {
        checkErrorBeforeSearchSumCOD (){ 
            return (this.search.dateStart || this.search.dateEnd) === "" ? false : true
        },
    },
    methods: {
        downloadFile(target) {
            const DATE_NOW = moment().format("DD-MM-YYYY")
            let url = target.data.data.url
            if(url){
                const link = document.createElement('a')
                link.href = url
                link.download = `ListCodReport-${DATE_NOW}.xlsx`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
        },
        formatNumber (num) {
            return parseFloat(num).toFixed(2)
        },
        ExportSumCOD () {
            const body = {
                date_start: this.search.dateStart,
                date_end: this.search.dateEnd,
                is_excel_report: true
            }
            const header = {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }
            this.$http.post(this.$API_URL + '/shippop/sum/managecod', body, header).then((res) => {
                this.downloadFile(res)
            })
        },
        getSumTotalCOD() {
            const body = {
                date_start: this.search.dateStart,
                date_end: this.search.dateEnd,
                is_excel_report: false,
            }
            const header = {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }
            let sumRes = []
            let fieldShowSum = []
            let resItem = []
            let getAllKeySumCOD = []
            this.$http.post(this.$API_URL + '/shippop/sum/managecod', body, header).then((res) => {
                sumRes = res.data.data
                const fieldShow = {
                    key: "sumDescription",
                    label: "สรุป",
                    sortable: false
                }
                fieldShowSum.push(fieldShow)
                sumRes.map((val) => {
                    const tempfieldPush = {
                        key: val.key,
                        label: courierName(val.key).name ? courierName(val.key).name : val.key,
                        sortable: false,
                        class:"text-right"
                    }
                    fieldShowSum.push(tempfieldPush)
                    getAllKeySumCOD.push(val.key)
                })
                for(let i = 0 ; i <= 2 ; i++) {
                    if(i == 0) {
                        let mapKeyValue = {}
                        sumRes.map((valKey) => {
                            mapKeyValue[valKey.key] = valKey.count_key
                        })
                        resItem.push({ sumDescription: "จำนวน Order", key: { ...mapKeyValue } })
                    }else if(i == 1) {
                        let mapKeyValue = {}
                        sumRes.map((valKey) => {
                            mapKeyValue[valKey.key] = this.formatNumber(valKey.total_cod_amount) 
                        })
                        resItem.push({ sumDescription: "COD Amount (THB)", key: { ...mapKeyValue } })
                    }else if (i == 2) {
                        let mapKeyValue = {}
                        sumRes.map((valKey) => {
                            mapKeyValue[valKey.key] = this.formatNumber(valKey.total_cod_charge_cost)
                        })
                        resItem.push({ sumDescription: "ค่าบริการ", key: { ...mapKeyValue } })
                    }
                }
            })
            this.fieldSumCOD = fieldShowSum
            this.ItemSumCOD = resItem
            this.allKeyTables = getAllKeySumCOD
        },
        getDataTransfer(val) {
            const body = {
                date_start: this.search.dateStart,
                date_end: this.search.dateEnd,
                name: this.search.name,
                status: this.search.status,
                is_excel_report: val === "is_excel_report" ? true : false
            }
            const header = {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }

            this.$http.post(this.$API_URL + '/shippop/cod/transfer', body,
            header,
            ).then((res) => {
                if(body.is_excel_report) {
                    this.downloadFile(res)
                }else {
                    this.items = res.data.data.data
                }
            })
        },
        openModal(val) {
          this.modal[val] = !this.modal[val]
        },
        close(val) {
            this.modal[val] = !this.modal[val]
        },
        menuAction(val) {
            this.menu =  val
        },
        statusChange(val) {
            this.search.status = val.target.value;
        },
    }
}
</script>